angular.module('TInv.dir.xmllint', []
).directive('xmlLint', function () {
    function hasErrors(lint, base) {
        if (!lint.errors)
            return false;
        return lint.errors.some((e) => (e.path && e.path.startsWith(base)));
    }
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            const base = attr.xmlLint;
            // $log.info('Lint dir on:', base);
            scope.$on('xmlLint', (ev, lint) => {
                // $log.info('Lint dir:', lint);
                if (hasErrors(lint, base))
                    element.addClass('schema-error');
                else
                    element.removeClass('schema-error');
            });
        }
    };
});
